const MARGIN = 5;
const TOP = 'top';
const BOTTOM = 'bottom';
const RIGHT = 'right';
const LEFT = 'left';

export type TooltipPlacement = 'top' | 'bottom' | 'right' | 'left';
type TooltipPosition = {
  top: number;
  left: number;
  placement: TooltipPlacement;
};

export function setTooltipPosition(
  trigger: HTMLElement | null,
  tooltip: HTMLElement | null,
  preferredPlacement: TooltipPlacement = TOP,
  forcePlacement = false,
): TooltipPosition {
  let placement: TooltipPlacement = preferredPlacement;
  const position: TooltipPosition = { top: 0, left: 0, placement: TOP };

  if (trigger && tooltip) {
    const triggerRect = trigger.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    if (!forcePlacement) {
      const tooltipWidth = tooltipRect.width;
      const tooltipHeight = tooltipRect.height;
      const fitsLeft = triggerRect.x - tooltipWidth > 0;
      const fitsRight =
        window.innerWidth - triggerRect.x - triggerRect.width > tooltipWidth;
      const fitsTop = triggerRect.y - tooltipHeight > 0;
      const fitsBottom =
        window.innerHeight - triggerRect.y - triggerRect.height > tooltipHeight;

      const placementYFitsInX =
        triggerRect.x + triggerRect.width / 2 - tooltipWidth / 2 > 0 &&
        window.innerWidth - triggerRect.x - triggerRect.width / 2 >
          tooltipWidth / 2;

      const placementXFitsInY =
        triggerRect.y + triggerRect.height / 2 - tooltipHeight / 2 > 0 &&
        window.innerHeight - triggerRect.y - triggerRect.height / 2 >
          tooltipHeight / 2;

      if (placement === TOP && !fitsTop) {
        placement = BOTTOM;
      } else if (placement === BOTTOM && !fitsBottom) {
        placement = TOP;
      } else if (placement === RIGHT && !fitsRight) {
        placement = LEFT;
      } else if (placement === LEFT && !fitsLeft) {
        placement = RIGHT;
      }

      if ([TOP, BOTTOM].includes(placement) && !placementYFitsInX) {
        if (fitsRight) {
          placement = RIGHT;
        } else {
          placement = LEFT;
        }
      } else if ([RIGHT, LEFT].includes(placement) && !placementXFitsInY) {
        if (fitsTop) {
          placement = TOP;
        } else {
          placement = BOTTOM;
        }
      }
    }

    switch (placement) {
      case BOTTOM:
        position.top = triggerRect.y + triggerRect.height + MARGIN;
        position.left =
          triggerRect.x + triggerRect.width / 2 - tooltipRect.width / 2;
        position.placement = BOTTOM;
        break;
      case RIGHT:
        position.top =
          triggerRect.y + triggerRect.height / 2 - tooltipRect.height / 2;
        position.left = triggerRect.x + triggerRect.width + MARGIN;
        position.placement = RIGHT;
        break;
      case LEFT:
        position.top =
          triggerRect.y + triggerRect.height / 2 - tooltipRect.height / 2;
        position.left = triggerRect.x - tooltipRect.width - MARGIN;
        position.placement = LEFT;
        break;
      default:
        position.top = triggerRect.y - tooltipRect.height - MARGIN;
        position.left =
          triggerRect.x + triggerRect.width / 2 - tooltipRect.width / 2;
        position.placement = TOP;
    }
  }

  return position;
}

export function findAncestor(element: HTMLElement): HTMLElement | null {
  let el: HTMLElement | null = element;
  while (el) {
    if (el && el.dataset.tooltip) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}
